import { ArticleParagraph2, ArticleParagraph3, Button, Checkbox, Input } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SettingsModalContent.css';

export interface IShareModalLandingContentProps {
  name: string;
  banner: React.ReactNode;
  hideNotes: boolean;
  hideOffersLink: boolean;
  hideAddresses: boolean;
  loading: boolean;
  canSubmit: boolean;
  isSearcherOrSub: boolean;
  onNameChange: (value: string) => void;
  onHideNotesChange: (value: boolean) => void;
  onHideOffersLinkChange: (value: boolean) => void;
  onHideAddressesChange: (value: boolean) => void;
  onSaveSettingsClick: () => void;
  onDeleteClick(): void;
  onCancel(): void;
}

export const SettingsModalContent: React.FunctionComponent<IShareModalLandingContentProps> = ({
  name,
  banner,
  hideNotes,
  hideOffersLink,
  hideAddresses,
  loading,
  canSubmit,
  isSearcherOrSub,
  onNameChange,
  onHideNotesChange,
  onHideOffersLinkChange,
  onHideAddressesChange,
  onSaveSettingsClick,
  onDeleteClick,
  onCancel,
}) => {
  const handleNameChange = React.useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onNameChange(value);
    },
    [onNameChange],
  );

  const handleHideNotesChange = React.useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      onHideNotesChange(!value);
    },
    [onHideNotesChange],
  );

  const handleHideOffersLinkChange = React.useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      onHideOffersLinkChange(!value);
    },
    [onHideOffersLinkChange],
  );

  const handleHideAddressesChange = React.useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      onHideAddressesChange(!value);
    },
    [onHideAddressesChange],
  );

  const handleDeleteClick = React.useCallback(() => {
    onDeleteClick();
  }, [onDeleteClick]);

  const handleCancelClick = React.useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <>
      <div className={styles['input_title']}>
        <ArticleParagraph2>Название</ArticleParagraph2>
        <Input value={name} onChange={handleNameChange} />
      </div>

      <ArticleParagraph2>
        {isSearcherOrSub ? 'Выберите, что показать в подборке' : 'Что показать клиенту в подборке?'}
      </ArticleParagraph2>

      <div className={styles['checkboxes']}>
        <Checkbox
          label="Адреса объектов"
          checked={!hideAddresses}
          onChange={handleHideAddressesChange}
          data-test="hide_addresses"
        />
        <Checkbox
          label="Ссылки на объявления"
          checked={!hideOffersLink}
          onChange={handleHideOffersLinkChange}
          data-test="hide_offers_link"
        />
        <Checkbox
          label="Заметки к объектам"
          checked={!hideNotes}
          onChange={handleHideNotesChange}
          data-test="hide_notes"
        />
      </div>
      <div className={styles['banner']}>{banner}</div>

      <div className={styles['delete_button']}>
        <ArticleParagraph2
          data-test="delete_button"
          data-name="FolderDeleteButton"
          onClick={handleDeleteClick}
          color="primary_100"
        >
          Удалить подборку
        </ArticleParagraph2>
        <ArticleParagraph3 color="gray60_100">Вы не сможете её восстановить</ArticleParagraph3>
      </div>

      <div className={styles['footer_actions']}>
        <Button data-test="cancel_button" theme="fill_white_primary" size="XS" onClick={handleCancelClick}>
          Отменить
        </Button>
        <Button
          disabled={canSubmit}
          loading={loading}
          data-test="submit_button"
          theme="fill_primary"
          size="XS"
          onClick={onSaveSettingsClick}
        >
          Сохранить
        </Button>
      </div>
    </>
  );
};
